<ng-container *ngIf="canEditGlobal">
  <app-loader *ngIf="loading"></app-loader>

  <ng-container *ngIf="!loading">
    <div class="row mt-4">
      <div class="col">
        <h3>Inspection App Licenses</h3>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col">
        <i>
          Manage Inspection App License settings for each jurisdiction and their departments.
          Enable licenses to allow non-departmental inspections or departmental inspections.
        </i>
      </div>
    </div>

    <div class="row ml-2 mt-3" *ngIf="clients.length === 0">
      <div class="flex-col pt-2">
        <i>No Jurisdictions to display</i>
      </div>
    </div>

    <div *ngIf="clients.length > 0">
      <div *ngFor="let state of statesSorted" class="mt-5">
        <h4 class="mb-3">{{ state }}</h4>
        <div class="accordion">
          <div class="card" *ngFor="let client of clientsByState.get(state)">
            <div class="card-header" id="heading{{ client.id }}">
              <div class="row align-items-center">
                <div class="col-auto">
                  <button
                    class="btn btn-link p-0"
                    type="button"
                    [attr.aria-expanded]="isClientExpanded(client.id)"
                    [attr.aria-controls]="'collapse' + client.id"
                    (click)="toggleClientExpanded(client.id)"
                  >
                    <i class="material-icons">
                      {{ isClientExpanded(client.id) ? 'expand_less' : 'expand_more' }}
                    </i>
                  </button>
                </div>
                <div class="col">
                  <h5 class="mb-0">{{ client.name }}</h5>
                </div>
              </div>
            </div>

            <div
              [id]="'collapse' + client.id"
              class="collapse"
              [class.show]="isClientExpanded(client.id)"
              [attr.aria-labelledby]="'heading' + client.id"
            >
              <div class="card-body">
                <!-- Client Level License -->
                <h6 class="mb-3">Non-Departmental Inspection App License</h6>
                <div class="table-responsive">
                  <table class="table table-sm">
                    <thead>
                      <tr>
                        <th style="width: 50%;">Description</th>
                        <th style="width: 20%;">License Status</th>
                        <th style="width: 30%;">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style="width: 50%;">
                          <small class="text-muted">
                            Enable this to allow the Jurisdiction to use the Inspection App for Mobile Inspection Workflows that are not assigned to a specific Department.
                          </small>
                        </td>
                        <td style="width: 20%;">
                          <span
                            *ngIf="client.hasNonDepartmentalInspectionAppLicense"
                            class="badge badge-success"
                          >
                            Enabled
                          </span>
                          <span
                            *ngIf="!client.hasNonDepartmentalInspectionAppLicense"
                            class="badge badge-secondary"
                          >
                            Disabled
                          </span>
                        </td>
                        <td style="width: 30%;">
                          <button
                            *ngIf="!client.hasNonDepartmentalInspectionAppLicense"
                            class="btn btn-raised btn-primary btn-sm"
                            (click)="toggleClientLicense(client)"
                            [disabled]="savingClientId === client.id"
                          >
                            <span *ngIf="savingClientId === client.id">
                              <i class="material-icons spinner">refresh</i>
                            </span>
                            <span *ngIf="savingClientId !== client.id">
                              Enable
                            </span>
                          </button>
                          <button
                            *ngIf="client.hasNonDepartmentalInspectionAppLicense"
                            class="btn btn-raised btn-danger btn-sm"
                            (click)="toggleClientLicense(client)"
                            [disabled]="savingClientId === client.id"
                          >
                            <span *ngIf="savingClientId === client.id">
                              <i class="material-icons spinner">refresh</i>
                            </span>
                            <span *ngIf="savingClientId !== client.id">
                              Disable
                            </span>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Departments Section -->
                <div *ngIf="getDepartmentsForClient(client.id).length > 0" class="mt-4">
                  <h6>Department Inspection App Licenses</h6>
                  <small class="text-muted">
                    Enable use of the Inspection App for individual Departments. Enabling a license for a Department allows that Department to use the Inspection App for its Mobile Inspection Workflows.
                  </small>
                  <div class="table-responsive">
                    <table class="table table-sm">
                      <thead>
                        <tr>
                          <th style="width: 50%;">Department Name</th>
                          <th style="width: 20%;">License Status</th>
                          <th style="width: 30%;">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let department of getDepartmentsForClient(client.id)">
                          <td style="width: 50%;">{{ department.name }}</td>
                          <td style="width: 20%;">
                            <span
                              *ngIf="department.hasInspectionAppLicense"
                              class="badge badge-success"
                            >
                              Enabled
                            </span>
                            <span
                              *ngIf="!department.hasInspectionAppLicense"
                              class="badge badge-secondary"
                            >
                              Disabled
                            </span>
                          </td>
                          <td style="width: 30%;">
                            <button
                              *ngIf="!department.hasInspectionAppLicense"
                              class="btn btn-raised btn-primary btn-sm"
                              (click)="toggleDepartmentLicense(department)"
                              [disabled]="savingDepartmentId === department.id"
                            >
                              <span *ngIf="savingDepartmentId === department.id">
                                <i class="material-icons spinner">refresh</i>
                              </span>
                              <span *ngIf="savingDepartmentId !== department.id">
                                Enable
                              </span>
                            </button>
                            <button
                              *ngIf="department.hasInspectionAppLicense"
                              class="btn btn-raised btn-danger btn-sm"
                              (click)="toggleDepartmentLicense(department)"
                              [disabled]="savingDepartmentId === department.id"
                            >
                              <span *ngIf="savingDepartmentId === department.id">
                                <i class="material-icons spinner">refresh</i>
                              </span>
                              <span *ngIf="savingDepartmentId !== department.id">
                                Disable
                              </span>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div *ngIf="getDepartmentsForClient(client.id).length === 0" class="mt-4">
                  <i class="text-muted">No departments available for this jurisdiction</i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<div *ngIf="!canEditGlobal" class="mt-4">
  <div class="alert alert-warning" role="alert">
    You do not have permission to manage Inspection App Licenses. Please contact your administrator.
  </div>
</div>
